import React from 'react';

/**
 * Carte bloc maquette — Commandes en cours / Rendez-vous planifiés.
 */
export default function MesCommandesMaquetteBlock({
  title,
  count,
  showTitleCount = true,
  icon: Icon,
  headerRight = null,
  children,
}) {
  return (
    <section className="rounded-2xl border border-gray-200 bg-white shadow-[0_10px_40px_-12px_rgba(37,99,235,0.25)] overflow-hidden">
      <header className="bg-gradient-to-r from-[#2563eb] to-[#2b6cb0] px-5 py-3.5 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          {Icon ? <Icon className="h-5 w-5 text-white flex-shrink-0" aria-hidden /> : null}
          <h2 className="text-base sm:text-lg font-bold text-white tracking-tight">
            {title}
            {showTitleCount && count != null ? (
              <span className="font-semibold opacity-95"> ({count})</span>
            ) : null}
          </h2>
        </div>
        {headerRight ? <div className="flex-shrink-0">{headerRight}</div> : null}
      </header>
      <div className="bg-white">{children}</div>
    </section>
  );
}

export function MesCommandesMaquetteEmptyRow({ colSpan, message }) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-6 py-10 text-center text-sm text-gray-500">
        {message}
      </td>
    </tr>
  );
}
